/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';
import { DATADOG_CONFIG } from './config';

/**
 * @class Logger
 * @classdesc Logs to datadog and in a development enviroment also `console.log`s. It passes along optional `context`.
 */
class Logger {
  /**
  * Constructs a new Logger
  * @param {string} [params.datadogClientToken=null] Datadog client_token
  * @param {object} [params.context={}] Additional data to pass along with each log method
  */
  constructor({
    datadogClientToken = null,
    context = {},
    enableConsole = false,
  } = {}) {
    this.datadogClientToken = datadogClientToken;
    this.context = context;
    this.enableConsole = enableConsole;
    this.#datadogInit();
  }

  /**
  * Info logger
  * @param {string} message
  * @param {object}
  */
  info(...all) { this.#log('info', ...all); }

  /**
  * Debug logger
  * @param {string} message
  * @param {object}
  */
  debug(...all) { this.#log('debug', ...all); }

  /**
  * Warn logger
  * @param {string} message
  * @param {object}
  */
  warn(...all) { this.#log('warn', ...all); }

  /**
  * Error logger
  * @param {string} message
  * @param {object}
  */
  error(...all) { this.#log('error', ...all); }

  #log(level, message, data = {}) {
    const payload = {
      kj_uploader_details: data,
      kj_uploader_context: this.context
    };

    if (this.#datadogEnabled()) datadogLogs.logger[level](message, payload);

    if (process.env.NODE_ENV === 'development' || this.enableConsole) {
      console[level]('%c[kj-uploader]', 'color: pink;', message, payload);
    }
  }

  #datadogInit() {
    if (!this.#datadogEnabled()) return;

    datadogLogs.init({
      clientToken: this.datadogClientToken,
      ...DATADOG_CONFIG
    });
  }

  #datadogEnabled() {
    return !!this.datadogClientToken;
  }
}

export default Logger;
